import { PlemsiTokenRepositoryImplementation } from '../infrastructure/plemsi-token-repository-implementation';
import { PlemsiToken } from '../domain/PlemsiToken/model';
import { EmptyArray } from "../domain/empty/model"; // for empty responses


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new PlemsiTokenRepositoryImplementation(); // uid and cid will need to be passed from context
const CACHE_PREFIX = 'plemsi_token';

async function updatePlemsiToken(users_id: number, token: string): Promise<PlemsiToken | undefined> {
  try {
    const result = await repo.updatePlemsiToken(users_id, token).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return result;
  } catch (error) {
    console.error("Error creating PlemsiToken:", error);
    throw error;
  }
}

async function getPlemsiToken(users_id: number): Promise<PlemsiToken | typeof EmptyArray> {
  try {
    const cacheKey = `${CACHE_PREFIX}-detail-${users_id}`;
    const cached = cacheManager.getItem<PlemsiToken>(cacheKey);

    if (cached) {
      console.log(`Returning PlemsiToken for users_id ${users_id} from cache`);
      return cached;
    }
    const result = await repo.getPlemsiToken(users_id).toPromise();
    const data = result.data;
    if (!data) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
  } catch (error) {
    console.error(`Error getting PlemsiToken for users_id ${users_id}:`, error);
    throw error;
  }
}

async function deletePlemsiToken(users_id: number): Promise<void> {
  try {
    await repo.deletePlemsiToken(users_id).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
  } catch (error) {
    console.error(`Error deleting PlemsiToken for users_id ${users_id}:`, error);
    throw error;
  }
}

export {
  getPlemsiToken,
  updatePlemsiToken,
  deletePlemsiToken,
};
